// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"3df73cab","496":"8d8889c6","647":"7fc27249"}[chunkId] + ".chunk.js";
};